(function(angular){
	'use strict';
	
	angular.module('collapseModule', []);

})(window.angular);